export const THRESHOLDS_DEFAULT_VALUES = {
  ON_TRACK: 70,
  BEHIND: 40
}
